import type { Id } from "@convex/_generated/dataModel";

export type ParticipantContext = {
  sessionId: Id<"sessions">;
  participantKey?: string | null;
  userId?: string | null;
  anonUserId?: string | null;
  timezone?: string | null;
};

/** The identity a participant's own todo list belongs to: a Clerk user, else the anonymous id. */
export function attachmentOwner(context: ParticipantContext): string | null {
  if (context.userId?.startsWith("user_")) return context.userId;
  return context.anonUserId ?? null;
}

export type ParticipantLifecycleHooks = {
  attach(context: ParticipantContext): void;
  detach(context: ParticipantContext): void | Promise<void>;
};

const hooks = new Set<ParticipantLifecycleHooks>();

export function registerParticipantLifecycleHooks(listener: ParticipantLifecycleHooks): () => void {
  hooks.add(listener);
  return () => hooks.delete(listener);
}

export function notifyParticipantAttached(context: ParticipantContext): void {
  hooks.forEach((listener) => listener.attach(context));
}

export function notifyParticipantDetached(
  context: ParticipantContext,
): Array<void | Promise<void>> {
  return Array.from(hooks, (listener) => listener.detach(context));
}
